module.exports = __webpack_public_path__ + "static/media/4.1b134222.jpg";